import { render } from "./HeroSection.vue?vue&type=template&id=22420692"
import script from "./HeroSection.vue?vue&type=script&lang=js"
export * from "./HeroSection.vue?vue&type=script&lang=js"

import "./HeroSection.vue?vue&type=style&index=0&id=22420692&lang=css"

import exportComponent from "/home/runner/work/nikidekor-frontend/nikidekor-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__